
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ItemsStore } from '@/store/stores/ItemsStore'

@Component({})
export default class PriceFilter extends Vue {
  items: ItemsStore = ItemsStore.getInstance()
  priceRange: any = {
    minValue: 1,
    maxValue: 9999,
  }
  minValue: any = 1
  maxValue: any = 9999

  changeMinimum() {
    if (this.minValue > this.maxValue - 500) {
      this.minValue = this.maxValue - 500
    }
  }
  changeMaximum() {
    if (this.maxValue - 500 < this.minValue) {
      this.maxValue = this.minValue + 500
    }
  }
  applyFilter() {
    this.priceRange.minValue = this.minValue
    this.priceRange.maxValue = this.maxValue
    this.$emit('range-updated', this.priceRange)
  }
}
